import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import { ReportNotificationsSubscription } from '@app/shared/models/smart-report.model';

@Injectable()
/* eslint-disable brace-style */
export class UserReportNotificationSubscriptionAdapter
    implements Adapter<ReportNotificationsSubscription>
{
    adapt(data: any): ReportNotificationsSubscription {
        return {
            subscribed: data.globalReportsEmail || false,
            active: data.active || false,
            reportTypes:
                data.reportTypes?.map((reportTypeSubscription) => {
                    return {
                        id: reportTypeSubscription.reportTypeId || 0,
                        subscribed: reportTypeSubscription.globalTypeEmail || false,
                        active: reportTypeSubscription.active || false,
                        configs:
                            reportTypeSubscription.reportConfigs?.map((config: any) => {
                                return {
                                    id: config.reportConfigId || 0,
                                    name: config.reportConfigName || '',
                                };
                            }) || [],
                    };
                }) || [],
        };
    }
}
/* eslint-enable brace-style */
